import { usePermission, Permissions } from '@billda/permissions-ui';
import { useOrganizationRoles } from '../../organisation/hooks/useOrganizationRoles';
import { getAssignableRoles } from '../utils/roleChangePolicy';

/**
 * Organisation roles filtered to those the current user may assign.
 * Prefer this over useOrganizationRoles for any role-picking UI so a new
 * call site can't re-expose roles the backend would reject.
 */
export function useAssignableRoles(
  options?: Parameters<typeof useOrganizationRoles>[0]
) {
  const query = useOrganizationRoles(options);
  const canManageAdmins = usePermission(Permissions.Users.ManageAdmins);

  return {
    ...query,
    canManageAdmins,
    assignableRoles: getAssignableRoles(query.data ?? [], canManageAdmins),
  };
}
